import * as React from 'react';

function Cash(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.572 16.644l4.434 3.166c.184.145.401.219.622.219.206 0 .416-.065.601-.191l4.69-2.973v.812l-.445.285-4.723 2.995c-.054.038-.135.072-.22.005L2 17.012l.572-.368zm0-1.885l4.434 3.166c.182.144.402.22.638.22.19 0 .388-.05.583-.15l4.691-2.938v.74l-5.167 3.275c-.054.04-.135.072-.22.006l-4.634-3.31a.427.427 0 00-.11-.079L2 15.127l.572-.368zm4.37-4.687l5.646 4.127-4.79 3.001c-.036.02-.162.076-.267-.008l-4.633-3.308a.422.422 0 00-.113-.08l-.784-.56 4.94-3.172zM9.388 8.5l5.99 4.263v3.342l-1.574 1.006v-2.906c0-.008-.005-.014-.006-.022l-.003-.014a.455.455 0 00-.177-.335L7.754 9.55 9.388 8.5zm10.752 3.742l.61.43-4.487 2.867v-.835l3.877-2.462zm-.485-2.248l1.1.788-4.492 2.853v-.865a20.65 20.65 0 003.392-2.776zM15.285 3l5.662 4.068c-1.264 1.828-3.1 3.587-5.118 4.91L10.2 7.973C12.17 6.655 13.984 4.887 15.284 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Cash;
